<template>
  <vs-row>
    <vs-col>
      <vs-row>
        <vs-col>
          <div class="vx-card__title mb-6"><h4 class="">Member (Accepted Referral) Stats</h4></div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-w="4">
          <dashboard-statistic :value="membersStatsResource.acceptedReferralsLastNinetyDays" label="Accepted Referrals in the Last 90 Days"></dashboard-statistic>
        </vs-col>

        <vs-col vs-w="4">
          <dashboard-statistic :value="membersStatsResource.referralAcceptanceRate" label="My Acceptance Rate in the Last 90 Days" :isPercentage="true"></dashboard-statistic>
        </vs-col>

        <vs-col vs-w="4">
          <dashboard-statistic :value="membersStatsResource.membersTotalCount" label="My Total Accepted Referrals"></dashboard-statistic>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import DashboardStatistic from '@/views/app/dashboard-statistic';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'dashboard-member-stats',
  components: {DashboardStatistic},
  props: {
    membersStatsResource: ResourceImpl
  },
  data () {
    return {
      statsLocal: null
    };
  }
};
</script>

<style scoped>

</style>
